import { render, staticRenderFns } from "./log-records.vue?vue&type=template&id=428dd46b"
import script from "./log-records.vue?vue&type=script&lang=ts"
export * from "./log-records.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports